module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan3-2-e225a6f698dd3380c8e66966d9a5f189.webp";